import request from '@host-panel/request';

type Response = {
  users: Record<string, any>;
};

export function fetchTeam(): Promise<Response> {
  return request(`/host-panel/team`, { method: 'GET' });
}
